import { ProtocolType, PROTOCOL_TYPE_CODE } from './enums';

/** Belegnummer: AP-UEB-2026-000123 */
export function protocolNumber(type: ProtocolType, year: number, seq: number): string {
  return `AP-${PROTOCOL_TYPE_CODE[type]}-${year}-${String(seq).padStart(6, '0')}`;
}

const DE_DATE = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'Europe/Berlin',
});
const DE_DATETIME = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Berlin',
});

export const formatDate = (d: Date | string): string =>
  DE_DATE.format(typeof d === 'string' ? new Date(d) : d);

export const formatDateTime = (d: Date | string): string =>
  `${DE_DATETIME.format(typeof d === 'string' ? new Date(d) : d)} Uhr`;

export const formatKm = (km?: number | null): string =>
  km == null ? '—' : `${new Intl.NumberFormat('de-DE').format(km)} km`;

export const fullName = (p: { firstName?: string | null; lastName?: string | null }): string =>
  [p.firstName, p.lastName].filter(Boolean).join(' ').trim() || '—';

/** Dateiname fuer den PDF-Export. */
export function pdfFileName(number: string, plate: string): string {
  const safePlate = plate.replace(/[^A-Za-z0-9]+/g, '-');
  return `${number}_${safePlate}.pdf`;
}
